import Evented from '@ember/object/evented';
import Service from '@ember/service';

export default class MessageBusService extends Service.extend(Evented) {}
